export default customElements.define('w-select-native', class SelectNative extends wealthify.CustomElementBaseClass {

    constructor () {
        const styleSelector = 'c-select-native';
        const config = {
            styleSelector: styleSelector,
            templateHTML: `
                <div class="${styleSelector}__wrapper" data-root>
                    <div class="${styleSelector}__select-container">
                        <label class="${styleSelector}__label" data-label></label>
                        <span data-slot="input" data-input></span>
                        </select>
                        <w-icon type="caret-down" class="${styleSelector}__caret-icon" data-careticon ></w-icon>
                    </div>
                    <w-icon class="${styleSelector}__state-icon" data-stateicon></w-icon>
                </div>`,
            cacheDom: [ 'data-careticon', 'data-label', 'data-stateicon', 'data-input' ],
            defaultSlotContents: {input: `<select required data-input class="${styleSelector}__input" data-slot="input">`,},
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);

            this.previousValidity = null;

            this._setLabel();
            
            this.dom.input.addEventListener('change', (event) => this.selected = event.currentTarget.value);
            
            this.dom.input.addEventListener('click', () => this.dom.careticon.type = this.dom.careticon.type === 'caret-down' ? 'caret-up' : 'caret-down');

            this.addEventListener('blur', () => {
                this.dom.careticon.type = 'caret-down';

                if (this.valid) {
                    this.classList.remove(`${this.styleSelector}--valid`);
                    this.dom.stateicon.type = 'no-icon';
                }
            }, true);
        };
    }

    static get observedProps () {
        return [
            new wealthify.Prop('label'),
            new wealthify.Prop('key'),
            new wealthify.Prop('items', { type: wealthify.propTypes.Array() }),
            new wealthify.Prop('placeholderprop'),
            new wealthify.Prop('required', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('selected'),
            wealthify.props.Disabled()
        ];
    }

    get propCallbacks () {
        return {
            label: () => this._setLabel(),

            key: () => {
                this.dom.input.id = this.key;
                this.dom.input.name = this.key;
            },

            placeholderprop: () => this._setItems(),

            required: () => {
                this.dom.input.required = this.required;
            },

            items: () => this._setItems(),

            selected: () => {
                this._setValue();
                if (!this.skipStateToggle) {
                    this._fireStateRefresh();
                }
                
                this.skipStateToggle = false;
            }
        };
    }

    get value () {
        return !this._getSelectedItem() ? this._getSelectedItem() : this._getSelectedItem().value;
    }

    get valid () {
        return this.dom.input.checkValidity();
    }

    _getSelectedItem () { 

        if (!this.selected) {
            return undefined;
        }

        const items = [...this.dom.input.options].filter(item => item.value === this.selected || item.label === this.selected);
            
        if (items.length > 0) {
            return { 
                value: items[0].value,
                label: items[0].label 
            };
        }

        return undefined;
    }

    _dispatchEvent () {
        const event = document.createEvent('Event');
        
        event.initEvent('valuechange', true, true);
        this.dispatchEvent(event);
    }

    _setValue() {
        if (this.selected && this.selected !== undefined) {

            const items = Array.prototype.filter.call(
                this.dom.input.options, 
                (item) => item.value === this.selected || item.label === this.selected
            );

            if (items.length > 0) {
                this.dom.input.value = items[0].value;
            }
        } else {
            this.skipStateToggle = true;
            this.selected = this.dom.input.options[0].value;
        }
    }

    _toggleState () {
        const wasInvalidated = this.valid === false;
        const wasCorrected = this.previousValidity == false && this.valid;
        const remainsCorrect = this.previousValidity && this.valid;
        const validClassListAction = wasCorrected || remainsCorrect ? 'add' : 'remove';
        const invalidClassListAction = wasInvalidated ? 'add' : 'remove';

        let icon = wasInvalidated ? 'danger-outlined' : 'no-icon';

        if (remainsCorrect) {
            return;
        }

        if (wasCorrected) {
            icon = 'success-outlined';
        }
        
        this.classList[validClassListAction](`${this.styleSelector}--valid`);
        this.classList[invalidClassListAction](`${this.styleSelector}--invalid`);
        this.dom.stateicon.type = icon;
    }

    _setItems() {

        if (this.items === undefined) {
            this.items = [];
        }

        this.dom.input.innerHTML = '';

        if (this.placeholderprop !== undefined) {
            const placeholderObj = { 
                label: this.placeholderprop, 
                value: ''
            };

            let placeholder = this._createItems(placeholderObj, `${this.styleSelector}__item--default`);

            this.dom.input.appendChild(placeholder);
        }

        let items = this._createItems(this.items, `${this.styleSelector}__item`);
        
        this.dom.input.appendChild(items);
        
        this._setValue();
    }

    _createItems(items, className) {

        let fragment = document.createDocumentFragment();
        
        if (typeof items === 'object' && !Array.isArray(items)) {
            items = [items]; // Convert object to array
        }

        for(let item in items) {
            let optionElement = document.createElement('OPTION');
            
            optionElement.classList.add(className);
            optionElement.setAttribute('value', items[item].value);
            optionElement.innerHTML = items[item].label;

            fragment.appendChild(optionElement);
        }

        return fragment;
    }

    _setLabel() {
        const addLabel = (this.label !== undefined && this.label.length > 0);
        const labelClassListAction = addLabel ? 'remove' : 'add';
        const inputClassListAction = addLabel ? 'add' : 'remove';

        this.dom.label.classList[labelClassListAction]('u-display__none');
        this.dom.input.classList[inputClassListAction](`${this.styleSelector}__input--has-label`);

        this.dom.label.innerHTML = this.label;
    }

    _fireStateRefresh () {
        this._toggleState();
        this._dispatchEvent();

        this.previousValidity = this.valid;
    }

    fireValidation () {
        this._fireStateRefresh();
    }

});